import CityPageTemplate from './CityPageTemplate';

export default function WinterGardenPage() {
  return (
    <CityPageTemplate
      city="Winter Garden"
      county="Orange"
      slug="winter-garden"
      zipCodes={['34787']}
      neighborhoods={['Downtown Winter Garden', 'Plant Street Market area', 'Fowler Groves', 'Lake Apopka North Shore', 'Stoneybrook West']}
      localContext="Winter Garden's charming Plant Street downtown and the booming Horizon West corridor make it one of Central Florida's most sought-after communities — and we keep it spotless."
      metaDescription="Professional residential and commercial cleaning services in Winter Garden, FL. Serving ZIP code 34787. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
